module.exports = __webpack_public_path__ + "static/assets/64bcd7fd15c0af65e35e1b9a259142c2.svg";